function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_971_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_977_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1030_",
  d: "M457.671,98.001h15.83c5.522,0,10-4.478,10-10s-4.478-10-10-10h-38c-5.522,0-10,4.478-10,10v38     c0,5.522,4.478,10,10,10s10-4.478,10-10v-11.003c30.342,40.621,46.835,89.908,46.835,141.17     c0,130.224-105.944,236.168-236.168,236.168S20,386.392,20,256.168S125.944,20,256.168,20c9.631,0,19.324,0.585,28.812,1.738     c5.475,0.662,10.468-3.237,11.134-8.72c0.667-5.482-3.237-10.468-8.72-11.134C277.108,0.634,266.603,0,256.168,0     C187.743,0,123.413,26.646,75.03,75.03C26.646,123.413,0,187.743,0,256.168s26.646,132.755,75.03,181.138     c48.383,48.384,112.713,75.03,181.138,75.03s132.755-26.646,181.138-75.03c48.384-48.383,75.03-112.713,75.03-181.138     C512.336,198.427,493.046,142.995,457.671,98.001z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1029_",
  d: "M108.472,151.013c-4.667-2.954-10.844-1.564-13.799,3.1c-22.829,36.056-32.935,79.418-28.456,122.099     c4.545,43.314,24.04,84.16,54.894,115.015c37.235,37.235,86.146,55.853,135.058,55.853s97.822-18.617,135.058-55.853     c74.471-74.471,74.471-195.645,0-270.115c-30.807-30.806-71.586-50.294-114.828-54.874     c-42.602-4.515-85.917,5.512-121.958,28.229c-4.673,2.945-6.072,9.12-3.128,13.792c2.945,4.673,9.12,6.072,13.792,3.128     c67.938-42.82,155.105-33.007,211.979,23.867c66.673,66.673,66.673,175.157,0,241.83c-66.672,66.674-175.158,66.674-241.83,0     c-56.088-56.088-66.048-145.361-23.682-212.271C114.525,160.146,113.138,153.968,108.472,151.013z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1028_",
  d: "M386.169,266.33h12.332c5.522,0,10-4.478,10-10s-4.478-10-10-10h-12.332c-5.522,0-10,4.478-10,10     S380.646,266.33,386.169,266.33z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1004_",
  d: "M103.835,256.006c0,5.522,4.478,10,10,10h12.332c5.522,0,10-4.478,10-10s-4.478-10-10-10h-12.332     C108.313,246.006,103.835,250.483,103.835,256.006z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1001_",
  d: "M266.33,126.167v-12.332c0-5.522-4.478-10-10-10s-10,4.478-10,10v12.332c0,5.522,4.478,10,10,10     S266.33,131.689,266.33,126.167z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1415_",
  d: "M246.006,386.169v12.332c0,5.522,4.478,10,10,10s10-4.478,10-10v-12.332c0-5.522-4.478-10-10-10     S246.006,380.646,246.006,386.169z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_996_",
  d: "M206.044,191.901c-3.906-3.904-10.236-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143l33.891,33.891     c-2.597,4.84-4.074,10.367-4.074,16.233c0,18.996,15.454,34.45,34.45,34.45s34.45-15.454,34.45-34.45     c0-5.866-1.478-11.393-4.074-16.233l68.383-68.383c3.905-3.905,3.905-10.237,0-14.143c-3.906-3.904-10.236-3.904-14.143,0     l-68.383,68.383c-4.84-2.597-10.367-4.074-16.233-4.074s-11.393,1.478-16.233,4.074L206.044,191.901z M270.618,256.168     c0,7.968-6.482,14.45-14.45,14.45s-14.45-6.482-14.45-14.45s6.482-14.45,14.45-14.45S270.618,248.2,270.618,256.168z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_980_",
  d: "M135.248,135.248c1.87-1.86,2.939-4.44,2.939-7.07s-1.069-5.2-2.939-7.07     c-1.86-1.859-4.431-2.93-7.07-2.93c-2.63,0-5.21,1.07-7.07,2.93c-1.859,1.86-2.93,4.44-2.93,7.07c0,2.64,1.07,5.21,2.93,7.07     c1.86,1.859,4.44,2.93,7.07,2.93C130.817,138.178,133.388,137.107,135.248,135.248z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_979_",
  d: "M325.438,29.878c2.641,0,5.221-1.061,7.08-2.93c1.86-1.86,2.931-4.431,2.931-7.07     c0-2.63-1.07-5.21-2.931-7.07c-1.859-1.859-4.439-2.93-7.08-2.93c-2.63,0-5.21,1.07-7.069,2.93c-1.86,1.86-2.931,4.44-2.931,7.07     c0,2.64,1.07,5.21,2.931,7.07C320.228,28.817,322.808,29.878,325.438,29.878z"
})));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.336 512.336",
    style: {
      enableBackground: "new 0 0 512.336 512.336"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1031_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1564_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1185_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1207_",
    style: {
      fill: "#C0F0FB"
    },
    cx: 256.168,
    cy: 256.168,
    r: 181
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1187_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1205_",
    style: {
      fill: "#FF7480"
    },
    cx: 256.168,
    cy: 256.168,
    r: 24.45
  })))), _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.d329d2ac.svg";
export { ForwardRef as ReactComponent };